import {
    EdgesAction, SelectedEdgesAction, SwitchEdgesTypeAction, SetEdgesTensionAction, HalfSelectedEdgesAction
} from "../actions";
import {bezierEdge} from "../model";
import {combineReducers} from "redux";

const Edges = (state: Array<bezierEdge> = [], action: EdgesAction) => {
    switch (action.type) {
        case "INIT_EDGES":
            return action.initialState;
        default:
            return state;
    }
};


const SelectedEdges = (state: Array<number> = [], action: SelectedEdgesAction) => {
    switch (action.type) {
        case "INIT_SELECTED_EDGES":
            return action.newState;
        default:
            return state;
    }
};


const EdgesType = (state: boolean = true, action: SwitchEdgesTypeAction) => {
    switch (action.type) {
        case "SWITCH_EDGES_TYPE":
            return !state;
        default:
            return state;
    }
};

const EdgesTension = (state: number = 0, action: SetEdgesTensionAction) => {
    switch (action.type) {
        case "SET_EDGES_TENSION":
            return action.newState;
        default:
            return state;
    }
};

const HalfSelectedEdges = (state: Array<number> = [], action: HalfSelectedEdgesAction) => {
    switch (action.type) {
        case "SET_HALF_SELECTED_EDGES":
            return action.newState;
        default:
            return state;
    }
};

export default combineReducers({SelectedEdges, Edges, EdgesType, EdgesTension, HalfSelectedEdges});